var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progressStatistic"},[_c('h2',[_vm._v(_vm._s(_vm.message))]),_c('pie-chart',{attrs:{"data":_vm.data,"library":_vm.library}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }